const TOKEN_KEY = 'token'
const REFRESH_TOKEN_KEY = 'refresh_token'
const ADMIN_ID = 'adminId'
const ADMIN_DATA = 'admin_data'
const LANGS = 'langs'
const LANG_KEY = 'lang'
const CURRENT_LOCALE_KEY = 'currentLocale'

const TokenService = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY)
  },

  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY)
  },

  saveToken(accessToken) {
    localStorage.setItem(TOKEN_KEY, accessToken)
  },

  removeToken() {
    localStorage.removeItem(TOKEN_KEY)
  },

  saveRefreshToken(refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
  },

  removeRefreshToken() {
    localStorage.removeItem(REFRESH_TOKEN_KEY)
  },

  saveAdminId(id) {
    localStorage.setItem(ADMIN_ID, id)
  },

  getAdminId() {
    return localStorage.getItem(ADMIN_ID)
  },

  saveAdminData(data) {
    localStorage.setItem(ADMIN_DATA, data)
  },
  getAdminData() {
    return localStorage.getItem(ADMIN_DATA)
  },
  removeAdminData() {
    localStorage.removeItem(ADMIN_DATA)
  },
  saveLangs(data) {
    const value = typeof data === 'string' ? data : JSON.stringify(data)
    localStorage.setItem(LANGS, value)
  },
  getLangs() {
    const raw = localStorage.getItem(LANGS)

    if (!raw) {
      return null
    }

    try {
      return JSON.parse(raw)
    } catch {
      localStorage.removeItem(LANGS)
      return null
    }
  },
  setLang(lang) {
    localStorage.setItem(LANG_KEY, lang)
    localStorage.setItem(CURRENT_LOCALE_KEY, lang)
  },
  getLang() {
    return localStorage.getItem(LANG_KEY) || localStorage.getItem(CURRENT_LOCALE_KEY)
  },

  getTenant() {
    const storedTenant = window.localStorage.getItem('currentCountry')
    if (storedTenant) {
      return storedTenant
    }

    if (process.env.VUE_APP_TENANCY_LOCAL === 'true') {
      return process.env.VUE_APP_TENANCY_COUNTRY || null
    }

    return null
  }
}

export default TokenService
